@for (chatAttribute of chatAttributes; track chatAttribute) {
  <div class="item chat-fields-label d-flex pb-3 flex-xcontent-center">
    @for (attr of $any(chatAttribute) | keyvalue; track attr) {
      <div class="flex-it chat-attr-row">
        <ng-icon
          class="field-type-icon"
          [name]="
            setFieldIcon(CHAT_FIELDS_GROUP, { name: $any(attr.key) })?.icon
          "
          [style.color]="
            setFieldIcon(CHAT_FIELDS_GROUP, { name: $any(attr.key) })?.color
          "
          [attr.aria-label]="
            'Chat attribute ' + ($any(attr.key) | prettifyUnderscoredValues)
          "
        ></ng-icon>
        <span class="label">
          {{ $any(attr.key) | prettifyUnderscoredValues }}
        </span>
        @for (value of $any(attr.value); track value) {
          @if (hasChatAttributeValue(value)) {
            <span
              class="badge-pill"
              [ngClass]="{
                'msg-predictions': predictionKeys.includes($any(attr.key)),
                'flex-fill': !predictionKeys.includes($any(attr.key)),
              }"
            >
              {{ value }}
            </span>
          } @else {
            <span>Not available</span>
          }
        }
      </div>
    }
  </div>
}
